import { render, staticRenderFns } from "./NumberInputSic.vue?vue&type=template&id=06fd959f&scoped=true&"
import script from "./NumberInputSic.vue?vue&type=script&lang=js&"
export * from "./NumberInputSic.vue?vue&type=script&lang=js&"
import style0 from "./NumberInputSic.vue?vue&type=style&index=0&id=06fd959f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd959f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
